(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filter-javascript-utils"] && !Shopify.designMode) return;
  try {
    if (!window.CollectionFilterUtils) {
    window.CollectionFilterUtils = {
      normalizeOperator(operator) {
        if (operator === '<' || operator === '>' || operator === '=') return operator;
        return '=';
      },

      normalizeCriteria(criteria) {
        if (!Array.isArray(criteria)) return [];

        return criteria
          .map((criterion) => {
            if (typeof criterion === 'object' && criterion !== null) {
              return {
                value: criterion.value?.toString().toLowerCase().trim() || '',
                operator: this.normalizeOperator(criterion.operator)
              };
            }

            return {
              value: criterion?.toString().toLowerCase().trim() || '',
              operator: '='
            };
          })
          .filter((criterion) => criterion.value !== '');
      },

      buildCriteria(values, operators) {
        if (!Array.isArray(values)) return [];

        return values
          .map((value, index) => {
            const normalizedValue = value?.toString().toLowerCase().trim() || '';
            const operator = Array.isArray(operators)
              ? this.normalizeOperator(operators[index])
              : '=';

            return {
              value: normalizedValue,
              operator
            };
          })
          .filter((criterion) => criterion.value !== '');
      },

      isNumericFilterType(filterType) {
        return filterType === 'width-inch' || filterType === 'height-inch' || filterType === 'depth-inch';
      },

      matchesFilterCriterion(productValues, filterType, criterion) {
        if (!Array.isArray(productValues) || !productValues.length) return false;
        if (!criterion || criterion.value === '') return false;

        if (!this.isNumericFilterType(filterType)) {
          return productValues.includes(criterion.value);
        }

        const productNumber = parseFloat(productValues[0]);
        if (Number.isNaN(productNumber)) return false;

        const operator = this.normalizeOperator(criterion.operator);
        const targetValue = criterion.value;

        if (operator === '<') {
          const target = parseFloat(targetValue);
          if (Number.isNaN(target)) return false;
          return productNumber < target;
        }

        if (operator === '>') {
          const target = parseFloat(targetValue);
          if (Number.isNaN(target)) return false;
          return productNumber >= target;
        }

        if (targetValue.includes(':')) {
          const rangeParts = targetValue.split(':');
          if (rangeParts.length != 2) return false;

          const min = parseFloat(rangeParts[0]);
          const max = parseFloat(rangeParts[1]);
          if (Number.isNaN(min) || Number.isNaN(max)) return false;

          return productNumber >= min && productNumber < max;
        }

        const target = parseFloat(targetValue);
        if (Number.isNaN(target)) return false;

        return productNumber === target;
      }
    };
  }
  } catch(e) { console.error(e); }
})();

})();
